import _ from "lodash";

/**
 * 更新对应的数组对象值
 *
 * @param {array} array 用来迭代的集合
 * @param {object} value 要设置的值
 * @param {string|object|function} condition 条件
 * @returns {array}
 */
export const updateArray = (array, value, condition) => {
	let conditionFunction = () => false;

	if (typeof condition === "string") {
		conditionFunction = item => _.eq(item[condition], value[condition]);
	} else if (typeof condition === "object") {
		conditionFunction = item => _.every(condition, x => _.eq(item[x], value[x]));
	} else if (typeof condition === "function") {
		conditionFunction = item => condition(item, value);
	}

	return _.map(array, item => {
		if (conditionFunction(item)) {
			return _.assign(item, value);
		}

		return item;
	});
};

/**
 * 更新或创建对应的数组对象值
 *
 * @param {array} array 用来迭代的集合
 * @param {object} value 要设置的值
 * @param {string|object|function} condition 条件
 * @returns {array}
 */
export const updateOrCreate = (array, value, condition) => {
	let conditionFunction = () => false;

	if (typeof condition === "string") {
		conditionFunction = item => _.eq(item[condition], value[condition]);
	} else if (typeof condition === "object") {
		conditionFunction = item => _.every(condition, x => _.eq(item[x], value[x]));
	} else if (typeof condition === "function") {
		conditionFunction = item => condition(item, value);
	}

	let found = false;

	const result = _.map(array, item => {
		if (conditionFunction(item)) {
			found = true;
			return _.assign(item, value);
		}

		return item;
	});

	if (!found) {
		result.push(value);
	}

	return result;
};

const LAST_OPEN_PATH_KEY = "chat_upload_last_path";

// 保存上次打开的路径
export const saveLastOpenPath = (filePath) => {
	try {
		// 从完整路径中提取目录路径
		const pathParts = filePath.split(/[/\\]/);
		pathParts.pop(); // 移除文件名
		const directoryPath = pathParts.join("/");

		localStorage.setItem(LAST_OPEN_PATH_KEY, directoryPath);
	} catch (error) {}
};

// 获取上次打开的路径
export const getLastOpenPath = (filePath) => {
	try {
		return localStorage.getItem(LAST_OPEN_PATH_KEY) || "";
	} catch (error) {
		return "";
	}
};

/**
 * 判断文件是否是图片
 * @param {File} file
 * @returns {boolean}
 */
export const isImageFile=(file)=> {
  return file.type.startsWith('image/');
}

/**
 * 判断文件是否是视频
 * @param {File} file
 * @returns {boolean}
 */
export const isVideoFile=(file)=> {
  const videoTypes = ['mp4'];
  const fileExtension = file.name.split('.').pop().toLowerCase();
  return videoTypes.includes(fileExtension) || file.type.startsWith('video/');
}